import React from 'react'
import avatar from '@/images/ai_avatar.jpg'

const AiAvatar = () => {
  return <img src={avatar} alt="IA Produttivo, Manu's avatar" />;
}

export default AiAvatar
